class TokenExpiredError extends Error {
  constructor() {
    super("API Token Expired");
    this.name = "TokenExpiredError";
  }
}
class GenericAPIError extends Error {
  constructor(message) {
    super(message);
    this.name = "GenericAPIError";
  }
}
class DuplicatedFieldError extends Error {
  constructor() {
    super();
    this.message = "Invalid object. Unable to add field that already exists";
    this.name = "DuplicatedFieldError";
  }
}
export {
  DuplicatedFieldError,
  GenericAPIError,
  TokenExpiredError
};
